// Uses temporary design
import React, { ErrorInfo, ReactNode } from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Container, Typography } from '@mui/material';
import { type TFunction } from 'i18next';

interface ErrorBoundaryProps {
  children: ReactNode;
  t: TFunction;
}

interface ErrorBoundaryState {
  error?: Error;
  errorInfo?: ErrorInfo;
  hasError?: boolean;
}

class WrappedErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: undefined, errorInfo: undefined };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error: error, errorInfo: errorInfo });
  }

  render() {
    const { t } = this.props;

    if (this.state.hasError) {
      return (
        <Container component="main" maxWidth="xs" sx={{ mt: 2.5 }}>
          <Typography variant="h5" gutterBottom>
            {t('error.somethingWentWrong')}
          </Typography>
          <Typography variant="body1">{this.state?.error?.toString?.()}</Typography>
          <Typography variant="body2" color="text.primary">
            {this.state?.errorInfo?.componentStack}
          </Typography>
          <Button variant="contained" color="primary" onClick={() => window.location.reload()}>
            {t('error.tryAgain')}
          </Button>
        </Container>
      );
    }

    return this.props.children;
  }
}

const ErrorBoundary = withTranslation('common')(WrappedErrorBoundary);

export default ErrorBoundary;
